import { Injectable } from '@angular/core';
import { LocaleService } from './locale.service';
import { GlobalFunctionService } from './global-function.service';
import { PopupComponent } from '@app/components/popup/popup.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { DetectDeviceService } from './detect-device.service';
import { GlobalApiService } from './global-api.service';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class BaseService {

	formView: boolean = false;
	resourcePopupTriggered = false;
	menuUpdate = new Subject();

	constructor(
		private locale: LocaleService,
		private gfService: GlobalFunctionService,
		private popup: MatDialog,
		private detectDevice: DetectDeviceService,
		private globalApiService: GlobalApiService
	) {
	}

	userDetail(userID: number) {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			autoFocus: false,
			data: {
				action: 'dynamic',
				popup: true,
				component: import('../../modules/people/profile/profile.component'),
				componentData: [
					{
						variableName: 'userID',
						value: userID
					}
				]
			},
			disableClose: true,
			maxHeight: '100%',
			maxWidth: '100%',
			height: '100%'
		});
		return dialogRef.afterClosed();
	}

	getSnapshot(fileName) {
		const fileExt = '.' + fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
		const iconList = [
			{
				name: '.pdf',
				icon: 'assets/img/pdf.png'
			},
			{
				name: '.png',
				icon: 'assets/img/resource-default-image.jpg'
			},
			{
				name: '.jpg',
				icon: 'assets/img/resource-default-image.jpg'
			},
			{
				name: '.jpeg',
				icon: 'assets/img/resource-default-image.jpg'
			},
			{
				name: '.mp4',
				icon: 'assets/img/resource-default-image.jpg'
			},
			{
				name: '.avi',
				icon: 'assets/img/resource-default-image.jpg'
			},
			{
				name: '.mpeg',
				icon: 'assets/img/resource-default-image.jpg'
			},
			{
				name: '.doc',
				icon: 'assets/img/word.png'
			},
			{
				name: '.docx',
				icon: 'assets/img/word.png'
			},
			{
				name: '.txt',
				icon: 'assets/img/pdf.png'
			},
			{
				name: '.csv',
				icon: 'assets/img/pdf.png'
			},
			{
				name: '.xls',
				icon: 'assets/img/excel.png'
			},
			{
				name: '.xlsx',
				icon: 'assets/img/excel.png'
			},
			{
				name: '.ppt',
				icon: 'assets/img/ppt.png'
			},
			{
				name: '.pptx',
				icon: 'assets/img/ppt.png'
			}
		];
		let returnData = 'assets/img/dummy-img.png';
		const findData = iconList.find(items => items.name === fileExt);
		if (findData) {
			returnData = findData.icon;
		}
		return returnData;
	}

	get getRegistrationType() {
		return [
			{
				key: 1,
				value: this.locale.translate('open_for_all')
			},
			{
				key: 2,
				value: this.locale.translate('by_request')
			}
		];
	}

	referenceType(type: ReferenceType, value: number | string) {
		const data: any = this.getReference(type);
		if (type === 'badgeStatus') {
			return data.find((items) => value >= items.rangeFrom && ([null, undefined].includes(items.rangeTo) || (items.rangeTo && value <= items.rangeTo)));
		} else {
			return data.find((items) => items.value === value);
		}
	}

	getReference(type: ReferenceType) {
		switch (type) {
			case 'resourceType':
				return this.resourceType;
			case 'assignmentStatus':
				return this.assignmentStatus;
			case 'assignmentType':
				return this.assignmentType;
			case 'taskGroup':
				return this.taskGroup;
			case 'wgReqStatusType':
				return this.wgReqStatusType;
			case 'resourceFormat':
				return this.resourceFormat;
			case 'conversationStatus':
				return this.conversationStatus;
			case 'profileStatus':
				return this.profileStatus;
			case 'resourceStatus':
				return this.resourceStatus;
			case 'relationShip':
				return this.relationShip;
			case 'courseContentType':
				return this.courseContentType;
			case 'questionType':
				return this.questionType;
			case 'testStatus':
				return this.testStatus;
			case 'testQuestionStatus':
				return this.testQuestionStatus;
			case 'commonStatus':
				return this.commonStatus;
			case 'badgeStatus':
				return this.badgeStatus;
			case 'notificationStatus':
				return this.notificationStatus;
			case 'certificationStatus':
				return this.certificationStatus;
			case 'stimulationSteps':
				return this.stimulationSteps;
			case 'registrationStatus':
				return this.registrationStatus;
			case 'registrationRequestStatus':
				return this.registrationRequestStatus;
			case 'subscribeStatus':
				return this.subscribeStatus;
			default: return [];
		}
	}

	get resourceType(): Array<any> {
		// console.log(this.gfService.sessionUser, sessionStorage.getItem('locale'));
		if (this.gfService.sessionUser && !this.gfService.sessionUser.resourceTypes) {
			let resourceTypes = [];
			for (let item of this.gfService.sessionUser.tempResourceTypes) {
				let lang = sessionStorage.getItem('locale') || 'en';
				this.locale.localeContent[item.name] = (item.attributes && item.attributes.translation) ? item.attributes.translation[lang] : '';
				// console.log(this.locale.localeContent[item.name], item.name);
				let itemData: any = {
					key: item.name,
					caption: this.locale.translate(item.name),
					image: (item.attributes && item.attributes.image) ? item.attributes.image : '',
					value: item.resourceTypeID,
					editorial: item.editorial
				};
				resourceTypes.push(itemData);
			}
			this.gfService.sessionUser.resourceTypes = resourceTypes;
		}
		return (this.gfService.sessionUser && this.gfService.sessionUser.resourceTypes) ? this.gfService.sessionUser.resourceTypes : [];
		// return [
		// 	{
		// 		key: 'knowledgecard',
		// 		caption: this.locale.translate('knowledge_card'),
		// 		value: 1,
		// 		image: 'assets/img/resource-default-image.jpg',
		// 		editorial: false
		// 	},
		// 	{
		// 		key: 'knowledgeBead',
		// 		caption: this.locale.translate('knowledge_bead'),
		// 		value: 2,
		// 		image: 'assets/img/resource-default-image.jpg',
		// 		editorial: false
		// 	},
		// 	{
		// 		key: 'news',
		// 		caption: this.locale.translate('news'),
		// 		value: 3,
		// 		image: 'assets/img/resource-default-image.jpg',
		// 		editorial: true
		// 	},
		// 	{
		// 		key: 'playlist',
		// 		caption: this.locale.translate('playlist'),
		// 		value: 4,
		// 		image: 'assets/img/resource-default-image.jpg',
		// 		editorial: false
		// 	},
		// 	{
		// 		key: 'answer',
		// 		caption: this.locale.translate('answers'),
		// 		value: 5,
		// 		image: 'assets/img/resource-default-image.jpg',
		// 		editorial: false
		// 	},
		// 	{
		// 		key: 'course',
		// 		caption: this.locale.translate('course'),
		// 		value: 6,
		// 		image: 'assets/img/resource-default-image.jpg',
		// 		editorial: false
		// 	},
		// 	{
		// 		key: 'policy',
		// 		caption: this.locale.translate('policy'),
		// 		value: 7,
		// 		image: 'assets/img/resource-default-image.jpg',
		// 		editorial: true
		// 	},
		// 	{
		// 		key: 'learning',
		// 		caption: this.locale.translate('learning'),
		// 		value: 8,
		// 		image: 'assets/img/resource-default-image.jpg',
		// 		editorial: true
		// 	},
		// 	{
		// 		key: 'sop',
		// 		caption: this.locale.translate('sop'),
		// 		value: 9,
		// 		image: 'assets/img/resource-default-image.jpg',
		// 		editorial: true
		// 	},
		// 	{
		// 		key: 'learningContent',
		// 		caption: this.locale.translate('learning_content'),
		// 		value: 10,
		// 		image: 'assets/img/resource-default-image.jpg',
		// 		editorial: false
		// 	},
		// 	{
		// 		key: 'mooc',
		// 		caption: this.locale.translate('mooc'),
		// 		value: 11,
		// 		image: 'assets/img/resource-default-image.jpg',
		// 		editorial: false
		// 	},
		// 	{
		// 		key: 'internalEvent',
		// 		caption: this.locale.translate('internal_event'),
		// 		value: 12,
		// 		image: 'assets/img/resource-default-image.jpg',
		// 		editorial: false
		// 	},
		// 	{
		// 		key: 'externalEvent',
		// 		caption: this.locale.translate('external_event'),
		// 		value: 13,
		// 		image: 'assets/img/resource-default-image.jpg',
		// 		editorial: false
		// 	},
		// 	{
		// 		key: 'blog',
		// 		caption: this.locale.translate('blog'),
		// 		value: 14,
		// 		image: 'assets/img/resource-default-image.jpg',
		// 		editorial: true
		// 	}
		// ];
	}

	get assignmentStatus() {
		return [
			{
				key: 'assigned',
				caption: this.locale.translate('assigned'),
				value: 1
			},
			{
				key: 'submitted',
				caption: this.locale.translate('submitted'),
				value: 2
			},
			{
				key: 'reassigned',
				caption: this.locale.translate('reassigned'),
				value: 3
			},
			{
				key: 'closed',
				caption: this.locale.translate('closed'),
				value: 4
			},
			{
				key: 'aborted',
				caption: this.locale.translate('aborted'),
				value: 5
			},
			{
				key: 'overdue',
				caption: this.locale.translate('overdue'),
				value: 6
			}
		];
	}

	get assignmentType() {
		return [
			{
				key: 'completion',
				caption: this.locale.translate('completion'),
				value: 1
			},
			{
				key: 'submission',
				caption: this.locale.translate('submission'),
				value: 2
			}
		];
	}

	get notificationStatus() {
		return [
			{
				key: 'notSeen',
				caption: this.locale.translate('not_seen'),
				value: 1
			},
			{
				key: 'seen',
				caption: this.locale.translate('seen'),
				value: 2
			},
			{
				key: 'clicked',
				caption: this.locale.translate('clicked'),
				value: 3
			}
		];
	}

	get taskGroup() {
		return [
			{
				key: 'assignment',
				caption: this.locale.translate('assignment'),
				value: 1
			},
			{
				key: 'knowledgeCard',
				caption: this.locale.translate('knowledge_card'),
				value: 2
			},
			{
				key: 'workgroup',
				caption: this.locale.translate('workgroup'),
				value: 3
			},
			{
				key: 'course',
				caption: this.locale.translate('course'),
				value: 4
			},
			{
				key: 'moderation',
				caption: this.locale.translate('moderation'),
				value: 5
			},
			{
				key: 'askAnswer',
				caption: this.locale.translate('ask_answer'),
				value: 6
			},
			{
				key: 'events',
				caption: this.locale.translate('events'),
				value: 7
			},
			{
				key: 'mooc',
				caption: this.locale.translate('mooc'),
				value: 8
			}
		];
	}

	get wgReqStatusType() {
		return [
			{
				key: 'pending',
				caption: this.locale.translate('pending'),
				value: 1
			},
			{
				key: 'accepted',
				caption: this.locale.translate('accepted'),
				value: 2
			},
			{
				key: 'ignored',
				caption: this.locale.translate('ignored'),
				value: 3
			},
			{
				key: 'declined',
				caption: this.locale.translate('declined'),
				value: 4
			}
		];
	}

	get resourceFormat() {
		return [
			{
				key: 'video',
				caption: this.locale.translate('video'),
				value: 2,
				image: 'assets/img/resource-default-image.jpg',
				svgIcon: 'video_camera'
			},
			{
				key: 'audio',
				caption: this.locale.translate('audio'),
				value: 3,
				image: 'assets/img/resource-default-image.jpg',
				svgIcon: 'audio_headphone'
			},
			{
				key: 'document',
				caption: this.locale.translate('document'),
				value: 1,
				image: 'assets/img/resource-default-image.jpg',
				svgIcon: 'document'
			},
			{
				key: 'link',
				caption: this.locale.translate('link'),
				value: 5,
				image: 'assets/img/resource-default-image.jpg',
				svgIcon: 'external_link'
			},
			{
				key: 'page',
				caption: this.locale.translate('page'),
				value: 4,
				image: 'assets/img/resource-default-image.jpg',
				svgIcon: 'pages'
			},
			{
				key: 'image',
				caption: this.locale.translate('image'),
				value: 6,
				image: 'assets/img/resource-default-image.jpg',
				svgIcon: 'image_collection'
			},
			{
				key: 'scorm',
				caption: this.locale.translate('scorm'),
				value: 7,
				image: 'assets/img/resource-default-image.jpg',
				svgIcon: 'scorm'
			}
		];
	}

	get conversationStatus() {
		return [
			{
				key: 'moderation',
				caption: this.locale.translate('moderation'),
				value: 1
			},
			{
				key: 'published',
				caption: this.locale.translate('published'),
				value: 2
			},
			{
				key: 'rejected',
				caption: this.locale.translate('rejected'),
				value: 3
			}
		];
	}

	get profileStatus() {
		return [
			{
				key: 'pending',
				caption: this.locale.translate('pending'),
				value: 0,
				classes: ['warn']
			},
			{
				key: 'active',
				caption: this.locale.translate('active'),
				value: 1,
				classes: ['success']
			},
			{
				key: 'deactivated',
				caption: this.locale.translate('blocked'),
				value: 2,
				classes: ['error']
			},
			{
				key: 'deleted',
				caption: this.locale.translate('deleted'),
				value: 3,
				classes: ['error']
			}
		];
	}

	get resourceStatus() {
		return [
			{
				key: 'draft',
				caption: this.locale.translate('draft'),
				value: 1
			},
			{
				key: 'published',
				caption: this.locale.translate('published'),
				value: 2,
				classes: ['warn']
			},
			{
				key: 'moderation',
				caption: this.locale.translate('moderation'),
				value: 3
			},
			{
				key: 'rejected',
				caption: this.locale.translate('rejected'),
				value: 4
			}
		];
	}

	get commonStatus() {
		return [
			{
				key: 'draft',
				caption: this.locale.translate('draft'),
				value: 1
			},
			{
				key: 'published',
				caption: this.locale.translate('published'),
				value: 2,
				classes: ['warn']
			},
			{
				key: 'moderation',
				caption: this.locale.translate('moderation'),
				value: 3
			},
			{
				key: 'rejected',
				caption: this.locale.translate('rejected'),
				value: 4
			}
		];
	}

	get relationShip() {
		return [
			{
				key: 'manager',
				caption: this.locale.translate('manager'),
				value: 1
			},
			{
				key: 'managerIndirect',
				caption: this.locale.translate('managerIndirect'),
				value: 2
			},
			{
				key: 'wgPeer',
				caption: this.locale.translate('workGroupPeer'),
				value: 3
			},
			{
				key: 'peer',
				caption: this.locale.translate('peer'),
				value: 4
			}
		];
	}

	get courseContentType() {
		return [
			{
				key: 'learningContent',
				caption: this.locale.translate('learning_content'),
				value: 'LC',
				image: 'assets/img/resource-default-image.jpg',
				svgIcon: 'learning'
			},
			{
				key: 'reference',
				caption: this.locale.translate('reference'),
				value: 2,
				image: 'assets/img/resource-default-image.jpg',
				svgIcon: 'resource'
			},
			// {
			// 	key: 'assignment',
			// 	caption: this.locale.translate('assignment'),
			// 	value: 3,
			// 	image: 'assets/img/resource-default-image.jpg',
			// 	svgIcon: 'assignment'
			// },
			{
				key: 'assessment',
				caption: this.locale.translate('assessment'),
				value: 'AT',
				image: 'assets/img/resource-default-image.jpg',
				svgIcon: 'assessment'
			},
			{
				key: 'events',
				caption: this.locale.translate('event'),
				value: 'LC',
				image: 'assets/img/resource-default-image.jpg',
				svgIcon: 'events'
			},
			{
				key: 'moocs',
				caption: this.locale.translate('mooc'),
				value: 'LC',
				image: 'assets/img/resource-default-image.jpg',
				svgIcon: 'course'
			},
			{
				key: 'scorm',
				caption: this.locale.translate('scorm'),
				value: 'LC',
				image: 'assets/img/resource-default-image.jpg',
				svgIcon: 'scorm'
			}
		];
	}

	get questionType() {
		return [
			{
				key: 'mcq',
				caption: this.locale.translate('mcq'),
				value: 1
			}
		];
	}

	get testStatus() {
		return [
			{
				key: 'live',
				value: 1
			},
			{
				key: 'interrupted',
				value: 2
			},
			{
				key: 'completed',
				value: 3
			},
			{
				key: 'aborted',
				value: 4
			}
		];
	}

	get testQuestionStatus() {
		return [
			{
				key: 'notAttempted',
				value: 1
			},
			{
				key: 'attempted',
				value: 2
			},
			{
				key: 'answered',
				value: 3
			}
		];
	}


	get badgeStatus() {
		return [
			{
				key: 'platinum',
				caption: this.locale.translate('platinum'),
				value: 1,
				rangeFrom: 100
			},
			{
				key: 'gold',
				caption: this.locale.translate('gold'),
				value: 2,
				rangeFrom: 80,
				rangeTo: 90
			},
			{
				key: 'silver',
				caption: this.locale.translate('silver'),
				value: 3,
				rangeFrom: 60,
				rangeTo: 79
			},
			{
				key: 'bronze',
				caption: this.locale.translate('bronze'),
				value: 4,
				rangeFrom: 40,
				rangeTo: 59
			},
			{
				key: 'starter',
				caption: this.locale.translate('starter'),
				value: 5,
				rangeFrom: 0,
				rangeTo: 39
			}
		];
	}

	get certificationStatus() {
		return [
			{
				key: 'published',
				caption: this.locale.translate('published'),
				value: 1
			},
			{
				key: 'moderation',
				caption: this.locale.translate('moderation'),
				value: 2
			},
			{
				key: 'rejected',
				caption: this.locale.translate('rejected'),
				value: 3
			}
		];
	}


	get stimulationSteps() {
		return [
			{
				key: 'userEndorsement',
				value: 1
			},
			{
				key: 'skillEndorsement',
				value: 2
			},
			{
				key: 'recommendedResources',
				value: 3
			},
			{
				key: 'takeCourse',
				value: 4
			},
			{
				key: 'askQuestion',
				value: 5
			},
			{
				key: 'knowledgeCard',
				value: 6
			},
			{
				key: 'knowledgeBead',
				value: 7
			},
			{
				key: 'registerLearning',
				value: 8
			}
		];
	}

	processTime(effectiveDate, lessDayCount: number = 4) {
		const today: any = new Date();
		today.setHours(0, 0, 0, 0);
		const yesterday: any = new Date(today);
		const lessDay: any = new Date(today);

		const todayDate = today.getTime();
		const yesterdayDate = yesterday.setDate(yesterday.getDate() - 1);
		const lessDate = lessDay.setDate(lessDay.getDate() - lessDayCount);
		let showDay: any;

		if (effectiveDate >= todayDate) {
			showDay = this.gfService.fullDateDiff(
				effectiveDate,
				Date.now(),
				1,
				true
			).returnString;
		} else if (effectiveDate >= yesterdayDate) {
			showDay = this.locale.translate('yesterday');
		} else if (effectiveDate >= lessDate) {
			showDay = this.gfService.fullDateDiff(
				effectiveDate,
				Date.now(),
				1,
				true
			).returnString;
		} else if (new Date(effectiveDate).getFullYear() === new Date(todayDate).getFullYear()) {
			showDay = this.gfService.dateFormat(effectiveDate, 'd MMM');

		} else if (new Date(effectiveDate).getFullYear() < new Date(todayDate).getFullYear()) {
			showDay = this.gfService.dateFormat(effectiveDate, 'MMM y');
		}
		return showDay;
	}

	get getEvents() {
		return [
			{
				ID: 1,
				key: 'userAdd'
			}
		];
	}

	get getTriggers() {
		return [
			{
				ID: 1,
				key: 'byUser'
			}
		];
	}

	get registrationStatus() {
		return [
			{
				key: 'registered',
				value: 1
			},
			{
				key: 'registerLearning',
				value: 2
			},
			{
				key: 'noShow',
				value: 3
			},
			{
				key: 'cancel',
				value: 4
			}
		];
	}

	get registrationRequestStatus() {
		return [
			{
				key: 'pending',
				value: 0
			},
			{
				key: 'approved',
				value: 1
			},
			{
				key: 'declined',
				value: 2
			}
		];
	}
	get subscribeStatus() {
		return [
			{
				key: 1,
				value: this.locale.translate('allow'),
				description: this.locale.translate('only_uses_with_matching_attributes_text')
			},
			{
				key: 2,
				value: this.locale.translate('omit'),
				description: this.locale.translate('everyone_except_users_with_matching_text')
			}
		];
	}

	get defaultLogs() {
		const returnData: any = {
			userID: this.gfService.sessionUser.userID,
			ageGroup: null,
			tenure: null
			// name: this.gfService.sessionUser.name,
			// ageGroupID: null,
			// ageGroup: null
		};
		if (this.gfService.sessionUser.profile) {
			if (this.gfService.sessionUser.profile.functionRole.hasOwnProperty('ID')) {
				returnData.functionalRoleID = this.gfService.sessionUser.profile.functionRole.ID;
				// returnData.functionRole = this.gfService.sessionUser.profile.functionRole.name;
			}
			if (this.gfService.sessionUser.profile.department.hasOwnProperty('ID')) {
				returnData.departmentID = this.gfService.sessionUser.profile.department.ID;
				// returnData.department = this.gfService.sessionUser.profile.department.name;
			}
			if (this.gfService.sessionUser.profile.city.hasOwnProperty('ID')) {
				returnData.cityID = this.gfService.sessionUser.profile.city.ID;
				// returnData.city = this.gfService.sessionUser.profile.city.name;
			}
			if (this.gfService.sessionUser.profile.location.hasOwnProperty('ID')) {
				returnData.locationID = this.gfService.sessionUser.profile.location.ID;
				// returnData.location = this.gfService.sessionUser.profile.location.name;
			}
			if (this.gfService.sessionUser.profile.gender.hasOwnProperty('ID')) {
				returnData.genderID = this.gfService.sessionUser.profile.gender.ID;
				// returnData.gender = this.gfService.sessionUser.profile.gender.name;
			}
			if (this.gfService.sessionUser.profile.country.hasOwnProperty('ID')) {
				returnData.countryID = this.gfService.sessionUser.profile.country.ID;
				// returnData.country = this.gfService.sessionUser.profile.country.name;
			}
		}
		return returnData;
	}

	logUserActivity(eventName: string, eventType: string, triggers: Array<string>, additionalInfo?: { resourceData: any, [key: string]: any }) {
		if (eventName && triggers) {
			let apiData: any = {};
			// const event = this.getEvents.find(items => items.key === eventName);
			// if (event) {
			// 	apiData.eventID = event.ID;
			// }
			// const triggerArr = [];
			// if (triggers.length) {
			// 	for (const trigger of triggers) {
			// 		const data = this.getTriggers.find(items => items.key === trigger);
			// 		if (data) {
			// 			triggerArr.push(data.ID);
			// 		}
			// 	}
			// }
			apiData.eventID = eventName;
			apiData.eventType = eventType;
			// apiData.triggers = triggers;
			apiData = this.gfService.JSONMerge(apiData, this.defaultLogs);
			if (additionalInfo) {
				const additionalLog: any = {};
				if (additionalInfo.resourceData) {
					const resourceData = { ...additionalInfo.resourceData };
					additionalLog.refResourceID = resourceData.resourceID;
					additionalLog.source = 1;
					// additionalLog.title = resourceData.title;
					if (resourceData.resourceTypeID) {
						if (typeof resourceData.resourceTypeID === 'number') {
							resourceData.resourceTypeID = this.referenceType('resourceType', resourceData.resourceTypeID);
						}
						if (resourceData.resourceTypeID && Object.keys(resourceData.resourceTypeID).length) {
							if (['mooc', 'externalEvent'].includes(resourceData.resourceTypeID.key)) {
								additionalLog.source = 2;
							}
							additionalLog.resourceType = resourceData.resourceTypeID.value;
							// additionalLog.resourceTypeName = resourceData.resourceTypeID.key;
						}
					}
					if (resourceData.resourceFormat) {
						if (typeof resourceData.resourceFormat === 'number') {
							resourceData.resourceFormat = this.referenceType('resourceFormat', resourceData.resourceFormat);
						}
						if (resourceData.resourceFormat && Object.keys(resourceData.resourceFormat).length) {
							if (resourceData.resourceFormat.key === 'link') {
								additionalLog.source = 2;
							}
							additionalLog.format = resourceData.resourceFormat.value;
						}
					}
					let authors = [];
					if (resourceData.authors && resourceData.authors.length) {
						authors = resourceData.authors.map(data => {
							return data.userID;
							// return {
							// 	userID: data.userID,
							// 	name: `${data.firstName}${data.lastName
							// 		? ' ' + data.lastName
							// 		: ''}`
							// };
						});
					}
					additionalLog.authors = authors;
					// let keywords = [];
					// if (resourceData.keywords && resourceData.keywords.length) {
					// 	keywords = resourceData.keywords.map(data => {
					// 		return {
					// 			key: data.ID,
					// 			value: data.name
					// 		};
					// 	});
					// }
					// additionalLog.keywords = keywords;
					let skills = [];
					if (resourceData.skills && resourceData.skills.length) {
						skills = resourceData.skills.map(data => {
							return data.skill.key;
							// return {
							// 	key: data.skill.key,
							// 	value: data.skill.value,
							// 	competencies: []
							// };
						});
					}
					additionalLog.skills = skills;
					delete additionalInfo.resourceData;
				}
				apiData = this.gfService.JSONMerge(apiData, additionalLog);
			}
			if (additionalInfo && Object.keys(additionalInfo).length) {
				apiData = this.gfService.JSONMerge(apiData, additionalInfo);
			}
			// apiData.device = this.detectDevice.deviceType;
			// apiData.timeStamp = Date.now();
			const headers = {};
			this.globalApiService.addUserActivity(apiData, headers).subscribe(
				(response) => { },
				(error) => { }
			)
				.add(() => { });
		}
	}

	checkAccessControl(permissionCode: string | Array<string>): boolean {
		let returnValue = false;
		const currentUser = this.gfService.sessionUser;
		if (currentUser && currentUser.permissions && currentUser.permissions.length) {
			const permissionList = currentUser.permissions;
			if (Array.isArray(permissionCode) && permissionCode.length) {
				for (const code of permissionCode) {
					
					if (permissionList.includes(code)) {
						returnValue = true;
						break;
					}
				}
			} else if (permissionCode) {
				
				if (permissionList.includes(permissionCode)) {
					returnValue = true;
				}
			}
		}
		return returnValue;
	}

	checkModuleAccess(moduleCode: string | Array<string>): boolean {
		let returnValue = false;
		const currentUser = this.gfService.sessionUser;
		if (currentUser && currentUser.modulesAvailable && currentUser.modulesAvailable.length) {
			const modulePermissionList = currentUser.modulesAvailable;
			if (Array.isArray(moduleCode) && moduleCode.length) {
				for (const code of moduleCode) {
					if (modulePermissionList.includes(code)) {
						returnValue = true;
						break;
					}
				}
			} else if (moduleCode) {
				
				if (modulePermissionList.includes(moduleCode)) {
					returnValue = true;
				}
			}
		}
		return returnValue;
	}

	get resourceActions() {
		return {
			course: {
				create: false,
				edit: false,
				nominate: false,
				enroll: false,
				takeCourse: false,
				rating: false,
				forward: false,
				addToPlaylist: false,
				bookmark: false,
				assign: false,
				manage: false,
				assignment: false,
				settings: false,
				clipboard: false,
				progressBar: false,
				readLog: false,
				stats: false,
				publishUnPublish: false,
				delete: false,
				enrollments: false,
				organize: false,
				addActivity: false,
				addModule: false
			},
			resource: {
				create: false,
				edit: false,
				delete: false,
				conversation: 'hide',
				rating: false,
				forward: false,
				addToPlaylist: false,
				bookmark: false,
				assign: false,
				manage: false,
				assignment: false,
				settings: false,
				clipboard: false,
				progressBar: false,
				readLog: false,
				stats: false,
				publishUnPublish: false
			},
			manageResource: {
				create: false,
				publishUnPublish: false,
				edit: false,
				delete: false,
				conversation: 'hide',
				rating: false,
				forward: false,
				addToPlaylist: false,
				bookmark: false,
				assign: false,
				manage: false,
				settings: false,
				clipboard: false,
				progressBar: false,
				readLog: false,
				stats: false
			},
			playlist: {
				create: false,
				publishUnPublish: false,
				edit: false,
				delete: false,
				conversation: 'hide',
				organize: false,
				itemDelete: false,
				rating: false,
				forward: false,
				addToPlaylist: false,
				bookmark: false,
				assign: false,
				manage: false,
				assignment: false,
				settings: false,
				clipboard: false,
				makePublic: false,
				progressBar: false,
				readLog: false,
				stats: false,
				addResource: false
			},
			questionAnswer: {
				create: false,
				publishUnPublish: false,
				edit: false,
				delete: false,
				conversation: 'hide',
				joinInAsking: false,
				closeQuestion: false,
				askerChoice: false,
				rating: false,
				forward: false,
				addToPlaylist: false,
				bookmark: false,
				assign: false,
				manage: false,
				assignment: false,
				settings: false,
				clipboard: false,
				progressBar: false,
				readLog: false,
				stats: false
			},
			knowledgeBead: {
				create: false,
				publishUnPublish: false,
				edit: false,
				delete: false,
				conversation: 'hide',
				rating: false,
				forward: false,
				addToPlaylist: false,
				bookmark: false,
				assign: false,
				manage: false,
				assignment: false,
				settings: false,
				clipboard: false,
				progressBar: false,
				readLog: false,
				stats: false
			},
			knowledgeCard: {
				create: false,
				publishUnPublish: false,
				edit: false,
				delete: false,
				conversation: 'hide',
				addBead: false,
				deleteBead: false,
				settings: false,
				progressBar: false,
				readLog: false,
				assignment: false
			},
			assignment: {
				conversation: 'hide',
				rating: false,
				forward: false,
				addToPlaylist: false,
				bookmark: false,
				assign: false,
				manage: false,
				assignment: false,
				settings: false,
				clipboard: false,
				progressBar: false,
				registerLearning: false,
				requestForApproval: false,
				register: false,
				requestForRegistration: false,
				readLog: false,
				stats: false,
				enroll: false,
				takeCourse: false,
				enrollments: false,
			},
			manageUserPost: {
				publishUnPublish: false,
				edit: false,
				delete: false,
				conversation: 'hide',
				rating: false,
				forward: false,
				addToPlaylist: false,
				bookmark: false,
				assign: false,
				manage: false,
				settings: false,
				clipboard: false,
				progressBar: false,
				readLog: false,
				stats: false,
				organize: false,
				addResource: false,
				itemDelete: false
			},
			mooc: {
				publishUnPublish: false,
				edit: false,
				delete: false,
				conversation: 'hide',
				assignment: false,
				settings: false,
				rating: false,
				forward: false,
				clipboard: false,
				addToPlaylist: false,
				bookmark: false,
				assign: false,
				manage: false,
				registerLearning: false,
				readLog: false,
				stats: false,
				requestForApproval: false
			},
			internalEvent: {
				publishUnPublish: false,
				edit: false,
				delete: false,
				conversation: 'hide',
				assignment: false,
				settings: false,
				rating: false,
				forward: false,
				clipboard: false,
				addToPlaylist: false,
				bookmark: false,
				assign: false,
				manage: false,
				registerLearning: false,
				readLog: false,
				stats: false,
				requestForRegistration: false,
				register: false,
				registrationAndRequestCount: false
			},
			externalEvent: {
				publishUnPublish: false,
				edit: false,
				delete: false,
				conversation: 'hide',
				assignment: false,
				settings: false,
				rating: false,
				forward: false,
				clipboard: false,
				addToPlaylist: false,
				bookmark: false,
				assign: false,
				manage: false,
				registerLearning: false,
				readLog: false,
				stats: false,
				requestForApproval: false,
				registrationAndRequestCount: false
			},
			manageEvent: {
				edit: false,
				delete: false,
				conversation: 'hide',
				settings: false,
				rating: false,
				forward: false,
				addToPlaylist: false,
				bookmark: false,
				assign: false,
				manage: false,
				stats: false,
				publishUnPublish: false
			},
			SCORM: {
				create: false,
				edit: false,
				delete: false,
				conversation: 'hide',
				rating: false,
				forward: false,
				addToPlaylist: false,
				bookmark: false,
				assign: false,
				manage: false,
				assignment: false,
				settings: false,
				clipboard: false,
				progressBar: false,
				readLog: false,
				stats: false,
				publishUnPublish: false
			}
		};
	}

	getResourceAction(data: any, actionFrom: string, additionalInfo: any = {}) {

		let returnData: any = {};
		let currentUser = this.gfService.sessionUser;
		const resourceActions = this.resourceActions;
		const resourceData = { ...data };
		
		let resourceType;
		if (resourceData.resourceTypeID && typeof resourceData.resourceTypeID !== 'object') {
			resourceData.resourceTypeID = this.referenceType('resourceType', resourceData.resourceTypeID);
		}
		if (resourceData.resourceTypeID && typeof resourceData.resourceTypeID === 'object') {
			resourceType = resourceData.resourceTypeID.key;
		}
		let isAuthor = false;
		if (resourceData.authors && resourceData.authors.length && resourceData.authors.find(items => items.userID === currentUser.userID)) {
			isAuthor = true;
		}
		let isCreator = false;
		if (resourceData.createdBy && resourceData.createdBy === currentUser.userID) {
			
			isCreator = true;
		}
		if (resourceData && !resourceData.settings) {
			resourceData.settings = {};
		}
		let isPlaylistItem = false;
		if (!actionFrom || actionFrom === 'playlist_item') {
			if (actionFrom) {
				isPlaylistItem = true;
			}
			if (resourceData.resourceTypeID && typeof resourceData.resourceTypeID === 'object') {
				if (resourceType === 'knowledgecard') {
					actionFrom = 'knowledgeCard_forMe';
				} else if (resourceType === 'knowledgeBead') {
					actionFrom = 'knowledgeBead_forMe';
				} else if (resourceType === 'playlist') {
					actionFrom = 'playlist_forMe';
				} else if (resourceType === 'answer') {
					actionFrom = 'answer_all';
				} else if (resourceType === 'course') {
					actionFrom = 'course_all';
				} else if (resourceData.resourceTypeID && typeof resourceData.resourceTypeID === 'object' && resourceData.resourceTypeID.editorial) {
					actionFrom = 'learning_all';
				} else if (resourceType === 'mooc') {
					actionFrom = 'mooc_all';
				} else if (resourceType === 'internalEvent') {
					actionFrom = 'internalEvent_all';
				} else if (resourceType === 'externalEvent') {
					actionFrom = 'externalEvent_all';
				} else if (resourceType === 'SCORM') {
					actionFrom = 'scorm_all';
				}
			}
		}
		if (actionFrom) {
			if (['learning_all', 'learning_moderation'].includes(actionFrom)) {
				let actions = resourceActions.resource;
				actions.create = true;
				actions.manage = true;
				if (resourceData.settings) {
					if (resourceData.settings.bookmark) {
						actions.bookmark = true;
					}
					if (resourceData.settings.commenting) {
						actions.conversation = resourceData.settings.commenting;
					}
					if (resourceData.settings.forwarding) {
						actions.forward = true;
					}
					if (resourceData.settings.playlist) {
						actions.addToPlaylist = true;
					}
					if (resourceData.settings.rating) {
						actions.rating = true;
					}
				}
				actions.assignment = (isPlaylistItem) ? false : true;
				actions.stats = true;
				if (resourceData.status) {
					if (actions.conversation === 'show') {
						if (resourceData.status.key === 'moderation') {
							actions.conversation = 'inactive';
						} else if (resourceData.status.key === 'draft') {
							actions.conversation = 'hide';
						}
					}
					if (resourceData.status.key === 'published') {
						actions.clipboard = true;
						actions.readLog = true;
					}
					if (['published', 'moderation'].includes(resourceData.status.key)) {
						if (resourceType) {
							if (resourceType === 'knowledgeBead') {
								actions.publishUnPublish = this.checkAccessControl(['KB003', 'KB002']);
							} else if (resourceType === 'answer') {
								actions.publishUnPublish = this.checkAccessControl(['QS003', 'QS002']);
							} else if (resourceType === 'playlist') {
								actions.publishUnPublish = this.checkAccessControl(['PL003', 'PL002']);
							} else if (resourceData.resourceTypeID && typeof resourceData.resourceTypeID === 'object' && resourceData.resourceTypeID.editorial) {
								actions.publishUnPublish = this.checkAccessControl(['CON002', 'CON003']);
							} else {
								actions.publishUnPublish = true;
							}
						} else {
							actions.publishUnPublish = true;
						}
					}
				}

				if (this.checkAccessControl(['CON002', 'CON003'])) {
					actions.settings = true;
				}

				if (this.checkAccessControl(['CON001', 'CON003'])) {
					actions.edit = true;
					actions.delete=true;
				}

				if (isCreator) {
					actions.rating = false;
					if (resourceData.status) {
						if (resourceData.status.key === 'draft' || this.checkAccessControl(['CON001', 'CON003'])) {
							actions.delete = true;
						}
						if (resourceData.status.key === 'published') {
							actions.assign = resourceData.settings.assign;
						}
					}
				} else {
					if (resourceData.status) {
						
						if (['draft', 'moderation'].includes(resourceData.status.key) && this.checkAccessControl(['CON001', 'CON003'])) {
							actions.delete = true;
						}
						if (resourceData.status.key !== 'published') {
							actions.rating = false;
							actions.forward = false;
							actions.addToPlaylist = false;
							actions.bookmark = false;
						} else if (resourceData.status.key === 'published') {
							actions.progressBar = true;
							actions.assign = this.checkAccessControl('AGN001') && resourceData.settings.assign;
						}
					}
				}
				returnData = actions;
			} else if (['course_moderation', 'course_all', 'course_requests', 'promotion_course'].includes(actionFrom)) {
				let actions = resourceActions.course;
				actions.create = true;
				actions.manage = true;
				actions.assignment = (isPlaylistItem) ? false : true;
				actions.stats = true;
				if (resourceData.settings) {
					if (resourceData.settings.bookmark) {
						actions.bookmark = true;
					}
					if (resourceData.settings.forwarding) {
						actions.forward = true;
					}
					if (resourceData.settings.playlist) {
						actions.addToPlaylist = true;
					}
					if (resourceData.settings.rating) {
						actions.rating = true;
					}
				}
				if (this.checkAccessControl('RES002')) {
					actions.edit = true;
					actions.delete = true;
					actions.settings = true;
				}
				if (resourceData.status) {
					if (['published', 'moderation', 'draft'].includes(resourceData.status.key)) {
						if (this.checkAccessControl('RES002')) {
							actions.organize = true;
							actions.addActivity = true;
							actions.addModule = true;
						}
						if (this.checkAccessControl('RES002') && ['published', 'moderation'].includes(resourceData.status.key)) {
							actions.publishUnPublish = true;
							actions.enrollments = true;
						}
						if (resourceData.status.key === 'published') {
							actions.clipboard = true;
							if (resourceData.infoFields && resourceData.infoFields.course && resourceData.infoFields.course.enrolment && resourceData.infoFields.course.enrolment === 'approval') {
								actions.nominate = true;
							}
							
							if ([null,undefined,''].includes(resourceData.enrollmentDetail)||Object.keys(resourceData.enrollmentDetail).length===0) {
								actions.enroll = true;
							} else {
								actions.takeCourse = true;
							}
						}
					}
				}
				if (isCreator) {
					actions.readLog = true;
					actions.rating = false;
					actions.settings = true;
					if (resourceData.status) {
						if (resourceData.status.key === 'published') {
							actions.assign = resourceData.settings.assign;
						}
					}
				} else {
					if (resourceData.status) {
						if (resourceData.status.key !== 'published') {
							actions.rating = false;
							actions.forward = false;
							actions.addToPlaylist = false;
							actions.bookmark = false;
						} else if (resourceData.status.key === 'published') {
							actions.readLog = true;
							actions.assign = this.checkAccessControl('AGN001') && resourceData.settings.assign;
						}
					}
				}
				returnData = actions;
			} else if (['playlist_forMe', 'playlist_byMe', 'playlist_myWorkgroup'].includes(actionFrom)) {
				let actions = resourceActions.playlist;
				if (resourceData.settings) {
					if (resourceData.settings.bookmark) {
						actions.bookmark = true;
					}
					if (resourceData.settings.commenting) {
						actions.conversation = resourceData.settings.commenting;
					}
					if (resourceData.settings.forwarding) {
						actions.forward = true;
					}
					if (resourceData.settings.rating) {
						actions.rating = true;
					}
				}
				actions.create = true;
				actions.stats = true;
				if (resourceData.status) {
					if (actions.conversation === 'show') {
						if (resourceData.status.key === 'moderation') {
							actions.conversation = 'inactive';
						} else if (resourceData.status.key === 'draft') {
							actions.conversation = 'hide';
						}
					}
					if (['moderation', 'published'].includes(resourceData.status.key)) {
						if (resourceData.status.key === 'published') {
							actions.readLog = true;
							actions.assignment = (isPlaylistItem) ? false : true;
							actions.clipboard = true;
						}
						actions.publishUnPublish = this.checkAccessControl(['PL002', 'PL003']);
					}
					if (actions.forward && resourceData.status.key !== 'published') {
						actions.forward = false;
					}
				}

				if (this.checkAccessControl(['PL002', 'PL003'])) {
					actions.settings = true;
				}

				if (isCreator) {
					actions.edit = true;
					actions.delete = true;
					actions.rating = false;
					actions.organize = true;
					actions.itemDelete = true;
					actions.addResource = true;
					if (resourceData.status) {
						if (resourceData.status.key === 'draft') {
							actions.makePublic = this.checkAccessControl('PL001');
						}
						if (resourceData.status.key === 'published') {
							actions.assign = resourceData.settings.assign;
						}
					}
				} else {
					actions.organize = this.checkAccessControl(['PL002', 'PL003']);
					actions.itemDelete = this.checkAccessControl(['PL002', 'PL003']);
					actions.addResource = this.checkAccessControl(['PL002', 'PL003']);
					if (resourceData.status) {
						if (resourceData.status.key !== 'published') {
							actions.rating = false;
							actions.forward = false;
							actions.bookmark = false;
						} else if (resourceData.status.key === 'published') {
							actions.progressBar = true;
							actions.assign = this.checkAccessControl('AGN001') && resourceData.settings.assign;
						}
					}
				}
				returnData = actions;
			} else if (['answer_all', 'answer_moderation'].includes(actionFrom)) {
				let actions = resourceActions.questionAnswer;
				if (resourceData.settings) {
					if (resourceData.settings.bookmark) {
						actions.bookmark = true;
					}
					if (resourceData.settings.commenting) {
						actions.conversation = resourceData.settings.commenting;
					}
					if (resourceData.settings.forwarding) {
						actions.forward = true;
					}
					if (resourceData.settings.playlist) {
						actions.addToPlaylist = true;
					}
					if (resourceData.settings.rating) {
						actions.rating = true;
					}
				}
				actions.create = true;
				actions.stats = true;
				if (resourceData.status) {
					if (actions.conversation === 'show') {
						if (resourceData.status.key === 'moderation') {
							actions.conversation = 'inactive';
						} else if (resourceData.status.key === 'draft') {
							actions.conversation = 'hide';
						}
					}
					if (['moderation', 'published'].includes(resourceData.status.key)) {
						if (resourceData.status.key === 'published') {
							actions.readLog = true;
							actions.assignment = (isPlaylistItem) ? false : true;
							actions.clipboard = true;
						}
						actions.publishUnPublish = this.checkAccessControl(['QS002', 'QS003']);
					}
				}

				if (this.checkAccessControl(['QS002', 'QS003'])) {
					actions.settings = true;
				}

				if (this.checkAccessControl(['QS001']) && ['draft'].includes(resourceData.status.key)) {
					actions.edit = true;
				}

				if (this.checkAccessControl(['QS003'])) {
					actions.edit = true;
				}
				// if (isAuthor) {
				// 	actions.askerChoice = true;
				// }

				if (isCreator) {
					actions.askerChoice = true;
					if (actions.conversation !== 'inactive') {
						actions.closeQuestion = true;
					}
					actions.rating = false;
					if (resourceData.status) {
						if (resourceData.status.key === 'draft' || this.checkAccessControl(['QS001', 'QS003'])) {
							actions.delete = true;
						}
						if (resourceData.status.key === 'published') {
							actions.assign = resourceData.settings.assign;
						}
					}
				} else {
					if (resourceData.status) {
						if (resourceData.status.key === 'published') {
							actions.assign = this.checkAccessControl('AGN001') && resourceData.settings.assign;
							actions.progressBar = true;
							if (actions.conversation === 'show' && resourceData.authors && resourceData.authors.length && !resourceData.authors.find(items => items.userID === currentUser.userID)) {
								actions.joinInAsking = true;
							}
						} else {
							actions.rating = false;
							actions.forward = false;
							actions.addToPlaylist = false;
							actions.bookmark = false;
							actions.conversation = 'hide';
						}

						if (this.checkAccessControl(['QS001']) && ['draft'].includes(resourceData.status.key)) {
							actions.delete = true;
						}

						if (this.checkAccessControl(['QS003'])) {
							actions.delete = true;
						}
					}
				}
				returnData = actions;
			} else if (['knowledgeBead_forMe', 'knowledgeBead_byMe', 'knowledgeBead_moderation', 'knowledgeBead_myWorkgroup'].includes(actionFrom)) {
				let actions = resourceActions.knowledgeBead;
				if (resourceData.settings) {
					if (resourceData.settings.bookmark) {
						actions.bookmark = true;
					}
					if (resourceData.settings.commenting) {
						actions.conversation = resourceData.settings.commenting;
					}
					if (resourceData.settings.forwarding) {
						actions.forward = true;
					}
					if (resourceData.settings.playlist) {
						actions.addToPlaylist = true;
					}
					if (resourceData.settings.rating) {
						actions.rating = true;
					}
				}
				actions.create = true;
				actions.stats = true;
				if (resourceData.status) {
					if (actions.conversation === 'show') {
						if (resourceData.status.key === 'moderation') {
							actions.conversation = 'inactive';
						} else if (resourceData.status.key === 'draft') {
							actions.conversation = 'hide';
						}
					}
					if (['moderation', 'published'].includes(resourceData.status.key)) {
						if (resourceData.status.key === 'published') {
							actions.readLog = true;
							actions.assignment = (isPlaylistItem) ? false : true;
							actions.clipboard = true;
						}
						actions.publishUnPublish = this.checkAccessControl(['KB002', 'KB003']);
					}
				}

				if (this.checkAccessControl(['KB002', 'KB003'])) {
					actions.settings = true;
				}

				if (this.checkAccessControl(['KB001', 'KB003'])) {
					actions.edit = true;
				}

				if (isCreator) {
					actions.rating = false;
					if (resourceData.status) {
						if (['draft'].includes(resourceData.status.key) || this.checkAccessControl(['KB001', 'KB003'])) {
							actions.delete = true;
						}

						if (resourceData.status.key === 'published') {
							actions.assign = resourceData.settings.assign;
						}
					}
				} else {
					if (resourceData.status) {
						if (resourceData.status.key !== 'published') {
							actions.rating = false;
							actions.forward = false;
							actions.addToPlaylist = false;
							actions.bookmark = false;
						} else if (resourceData.status.key === 'published') {
							actions.progressBar = true;
							actions.assign = this.checkAccessControl('AGN001') && resourceData.settings.assign;
						}


						if (['draft', 'moderation'].includes(resourceData.status.key) && this.checkAccessControl(['KB001', 'KB003'])) {
							actions.delete = true;
						}
					}
				}
				returnData = actions;
			} else if (['knowledgeCard_forMe', 'knowledgeCard_byMe', 'knowledgeCard_myWorkgroup', 'knowledgeCard_item'].includes(actionFrom)) {
				let actions = resourceActions.knowledgeCard;
				if (resourceData.settings) {
					if (resourceData.settings.commenting) {
						actions.conversation = resourceData.settings.commenting;
					}
				}
				actions.create = true;
				if (resourceData.status) {
					if (actions.conversation === 'show') {
						if (resourceData.status.key === 'moderation') {
							actions.conversation = 'inactive';
						} else if (resourceData.status.key === 'draft') {
							actions.conversation = 'hide';
						}
					}
				}
				if (this.checkAccessControl(['KC001', 'RES001'])) {
					actions.edit = true;
				}
				actions.assignment = true;
				if (isCreator) {
					if (resourceData.status) {
						if (['draft', 'moderation'].includes(resourceData.status.key)) {
							actions.delete = true;
						}
					}
				} else {
					actions.deleteBead = true;
					actions.addBead = true;

					if (['draft', 'moderation'].includes(resourceData.status.key) && this.checkAccessControl(['KC001', 'RES001'])) {
						actions.delete = true;
					}
				}
				returnData = actions;
			} else if (['assignment_forMe', 'assignment_byMe', 'assignment_myWorkgroup'].includes(actionFrom)) {
				let actions = resourceActions.assignment;
				if (resourceData.settings) {
					if (resourceData.settings.bookmark) {
						actions.bookmark = true;
					}
					if (resourceData.settings.commenting) {
						actions.conversation = resourceData.settings.commenting;
					}
					if (resourceData.settings.forwarding) {
						actions.forward = true;
					}
					if (resourceData.settings.playlist) {
						actions.addToPlaylist = true;
					}
					if (resourceData.settings.rating) {
						actions.rating = true;
					}
				}
				actions.assignment = true;
				actions.progressBar = true;
				actions.stats = true;
				if (resourceData.status) {
					if (actions.conversation === 'show') {
						if (resourceData.status.key === 'moderation') {
							actions.conversation = 'inactive';
						} else if (resourceData.status.key === 'draft') {
							actions.conversation = 'hide';
						}
					}
					if (this.checkAccessControl('RES002') && ['published', 'moderation'].includes(resourceData.status.key)) {
						actions.enrollments = true;
					}
					if (resourceData.status.key === 'published') {
						actions.clipboard = true;
						
						if ([null,undefined,''].includes(resourceData.enrollmentDetail)||Object.keys(resourceData.enrollmentDetail).length===0) {
							actions.enroll = true;
						} else {
							actions.takeCourse = true;
						}
					}
				}

				// if (actionFrom === 'assignment_forMe') {
				// 	actions.readLog = true;
				// }
				if (isCreator) {
					actions.rating = false;
					//newly added readLog
					// actions.readLog = true;
					if (resourceData.status) {
						if (resourceData.status.key === 'published') {
							actions.assign = resourceData.settings.assign;
						}
					}
				} else {
					if (resourceData.status) {
						if (resourceData.status.key !== 'published') {
							actions.rating = false;
							actions.forward = false;
							actions.addToPlaylist = false;
							actions.bookmark = false;
						} else if (resourceData.status.key === 'published') {
							//newly added readLog
							// actions.readLog = true;
							actions.assign = this.checkAccessControl('AGN001') && resourceData.settings.assign;
						}
					}
				}
				returnData = actions;
			} else if (['mooc', 'mooc_all', 'mooc_moderation', 'mooc_requests', 'mooc_registrations', 'promotion_mooc'].includes(actionFrom)) {
				let actions = resourceActions.mooc;
				if (resourceData.settings) {
					if (resourceData.settings.bookmark) {
						actions.bookmark = true;
					}
					if (resourceData.settings.commenting) {
						actions.conversation = resourceData.settings.commenting;
					}
					if (resourceData.settings.forwarding) {
						actions.forward = true;
					}
					if (resourceData.settings.playlist) {
						actions.addToPlaylist = true;
					}
					if (resourceData.settings.rating) {
						actions.rating = true;
					}
				}
				actions.assignment = (isPlaylistItem) ? false : true;
				actions.stats = true;
				actions.registerLearning = true;
				actions.readLog = true;
				if (resourceData.status) {
					if (actions.conversation === 'show') {
						if (resourceData.status.key === 'moderation') {
							actions.conversation = 'inactive';
						} else if (resourceData.status.key === 'draft') {
							actions.conversation = 'hide';
						}
					}
					if (resourceData.status.key === 'published') {
						actions.clipboard = true;
					}

					if (['moderation', 'published'].includes(resourceData.status.key)) {
						actions.publishUnPublish = this.checkAccessControl('REG001');
					}
				}

				if (this.checkAccessControl(['MOOC002', 'MOOC003'])) {
					actions.settings = true;
				}

				if (this.checkAccessControl(['MOOC001', 'MOOC003'])) {
					actions.edit = true;
				}


				if (isCreator) {
					actions.rating = false;
					if (resourceData.status) {
						if (['draft'].includes(resourceData.status.key) || this.checkAccessControl(['MOOC001', 'MOOC003'])) {
							actions.delete = true;
						}
						if (resourceData.status.key === 'published') {
							actions.assign = resourceData.settings.assign;
						}
					}
				} else {
					actions.requestForApproval = true;
					if (resourceData.status) {
						if (resourceData.status.key !== 'published') {
							actions.rating = false;
							actions.forward = false;
							actions.addToPlaylist = false;
							actions.bookmark = false;
						} else if (resourceData.status.key === 'published') {
							actions.assign = this.checkAccessControl('AGN001') && resourceData.settings.assign;
						}

						if (['draft', 'moderation'].includes(resourceData.status.key) && this.checkAccessControl(['MOOC001', 'MOOC003'])) {
							actions.delete = true;
						}
					}
				}
				returnData = actions;
			} else if (['internalEvent_all', 'internalEvent_moderation', 'internalEvent_requests', 'internalEvent_registrations', 'promotion_internal_event'].includes(actionFrom)) {
				let actions = resourceActions.internalEvent;
				if (resourceData.settings) {
					if (resourceData.settings.bookmark) {
						actions.bookmark = true;
					}
					if (resourceData.settings.commenting) {
						actions.conversation = resourceData.settings.commenting;
					}
					if (resourceData.settings.forwarding) {
						actions.forward = true;
					}
					if (resourceData.settings.playlist) {
						actions.addToPlaylist = true;
					}
					if (resourceData.settings.rating) {
						actions.rating = true;
					}
				}
				actions.assignment = (isPlaylistItem) ? false : true;
				actions.stats = true;
				actions.registerLearning = true;
				actions.readLog = true;
				if (resourceData.status) {
					if (actions.conversation === 'show') {
						if (resourceData.status.key === 'moderation') {
							actions.conversation = 'inactive';
						} else if (resourceData.status.key === 'draft') {
							actions.conversation = 'hide';
						}
					}
					if (resourceData.status.key === 'published') {
						actions.clipboard = true;
					}

					if (['moderation', 'published'].includes(resourceData.status.key)) {
						actions.publishUnPublish = this.checkAccessControl('IEV003');
					}

				}
				actions.registrationAndRequestCount = this.checkAccessControl('REG001');

				if (this.checkAccessControl(['IEV002', 'IEV003'])) {
					actions.settings = true;
				}

				if (this.checkAccessControl(['IEV001', 'IEV003'])) {
					actions.edit = true;
				}

				if (isCreator) {
					actions.rating = false;
					if (resourceData.status) {
						if (['draft'].includes(resourceData.status.key) || this.checkAccessControl(['IEV001', 'IEV003'])) {
							actions.delete = true;
						}
						if (resourceData.status.key === 'published') {
							actions.assign = resourceData.settings.assign;
						}
					}
				} else {
					actions.requestForRegistration = true;
					actions.register = true;
					if (resourceData.status) {
						if (resourceData.status.key !== 'published') {
							actions.rating = false;
							actions.forward = false;
							actions.addToPlaylist = false;
							actions.bookmark = false;
						} else if (resourceData.status.key === 'published') {
							actions.assign = this.checkAccessControl('AGN001') && resourceData.settings.assign;
						}
						if (['draft', 'moderation'].includes(resourceData.status.key) && this.checkAccessControl(['IEV001', 'IEV003'])) {
							actions.delete = true;
						}
					}
				}
				returnData = actions;
			} else if (['externalEvent_all', 'externalEvent_moderation', 'externalEvent_requests', 'externalEvent_registrations', 'promotion_external_event'].includes(actionFrom)) {
				let actions = resourceActions.externalEvent;
				if (resourceData.settings) {
					if (resourceData.settings.assign) {
						actions.assign = this.checkAccessControl('AGN001');
						// actions.manage = true;
					}
					if (resourceData.settings.bookmark) {
						actions.bookmark = true;
					}
					if (resourceData.settings.commenting) {
						actions.conversation = resourceData.settings.commenting;
					}
					if (resourceData.settings.forwarding) {
						actions.forward = true;
					}
					if (resourceData.settings.playlist) {
						actions.addToPlaylist = true;
					}
					if (resourceData.settings.rating) {
						actions.rating = true;
					}
				}
				actions.assignment = (isPlaylistItem) ? false : true;
				actions.stats = true;
				actions.registerLearning = true;
				actions.readLog = true;
				actions.registrationAndRequestCount = this.checkAccessControl('REG001');
				if (resourceData.status) {
					if (actions.conversation === 'show') {
						if (resourceData.status.key === 'moderation') {
							actions.conversation = 'inactive';
						} else if (resourceData.status.key === 'draft') {
							actions.conversation = 'hide';
						}
					}
					if (resourceData.status.key === 'published') {
						actions.clipboard = true;
					}

					if (['moderation', 'published'].includes(resourceData.status.key)) {
						actions.publishUnPublish = this.checkAccessControl('EEV003');
					}
				}

				if (this.checkAccessControl(['EEV002', 'EEV003'])) {
					actions.settings = true;
				}

				if (this.checkAccessControl(['EEV001', 'EEV003'])) {
					actions.edit = true;
				}

				if (isCreator) {
					actions.rating = false;
					if (resourceData.status) {
						if (['draft'].includes(resourceData.status.key) || this.checkAccessControl(['EEV001', 'EEV003'])) {
							actions.delete = true;
						}
						if (resourceData.status.key === 'published') {
							actions.assign = resourceData.settings.assign;
						}
					}
				} else {
					actions.requestForApproval = true;
					if (resourceData.status) {
						if (resourceData.status.key !== 'published') {
							actions.rating = false;
							actions.forward = false;
							actions.addToPlaylist = false;
							actions.bookmark = false;
						} else if (resourceData.status.key === 'published') {
							actions.assign = this.checkAccessControl('AGN001') && resourceData.settings.assign;
						}

						if (['draft', 'moderation'].includes(resourceData.status.key) && this.checkAccessControl(['EEV001', 'EEV003'])) {
							actions.delete = true;
						}
					}
				}
				returnData = actions;
			} else if (['scorm_all'].includes(actionFrom)) {
				let actions = resourceActions.SCORM;
				actions.create = true;
				actions.manage = true;
				actions.assignment = (isPlaylistItem) ? false : true;
				actions.stats = true;
				if (resourceData.settings) {
					if (resourceData.settings.bookmark) {
						actions.bookmark = true;
					}
					if (resourceData.settings.forwarding) {
						actions.forward = true;
					}
					if (resourceData.settings.playlist) {
						actions.addToPlaylist = true;
					}
					if (resourceData.settings.rating) {
						actions.rating = true;
					}
				}
				if (this.checkAccessControl('RES002')) {
					actions.edit = true;
					actions.delete = true;
					actions.settings = true;
				}
				// if (resourceData.status) {
				// 	if (['published', 'moderation', 'draft'].includes(resourceData.status.key)) {
				// 		if (this.checkAccessControl('RES002')) {
				// 			actions.organize = true;
				// 			actions.addActivity = true;
				// 			actions.addModule = true;
				// 		}
				// 		if (this.checkAccessControl('RES002') && ['published', 'moderation'].includes(resourceData.status.key)) {
				// 			actions.publishUnPublish = true;
				// 			actions.enrollments = true;
				// 		}
				// 		if (resourceData.status.key === 'published') {
				// 			actions.clipboard = true;
				// 			if (resourceData.infoFields && resourceData.infoFields.course && resourceData.infoFields.course.enrolment && resourceData.infoFields.course.enrolment === 'approval') {
				// 				actions.nominate = true;
				// 			}
				// 			if (!resourceData.enrollmentDetail) {
				// 				actions.enroll = true;
				// 			} else {
				// 				actions.takeCourse = true;
				// 			}
				// 		}
				// 	}
				// }
				if (isCreator) {
					actions.readLog = true;
					actions.rating = false;
					actions.settings = true;
					if (resourceData.status) {
						if (resourceData.status.key === 'published') {
							actions.assign = resourceData.settings.assign;
						}
					}
				} else {
					if (resourceData.status) {
						if (resourceData.status.key !== 'published') {
							actions.rating = false;
							actions.forward = false;
							actions.addToPlaylist = false;
							actions.bookmark = false;
						} else if (resourceData.status.key === 'published') {
							actions.readLog = true;
							actions.assign = this.checkAccessControl('AGN001') && resourceData.settings.assign;
						}
					}
				}
				returnData = actions;
			}
		}

		if (additionalInfo && additionalInfo.defaultAction) {
			returnData = this.gfService.JSONMerge(returnData, additionalInfo.defaultAction);
		}
		// if (resourceData.settings) {
		// 	returnData.assign = this.checkAccessControl('AGN001') && resourceData.settings.assign;
		// }
		return returnData;
	}

	processSegmentLog(data, resourceID) {
		let storageData: any = [];
		if (localStorage.getItem('segmentData')) {
			storageData = JSON.parse(localStorage.getItem('segmentData'));
		}
		const findData = storageData.find(items => items.resourceID === resourceID);
		if (findData) {
			let segment = findData.segments.concat(data.segments);
			let newSegments = findData.newSegments || [];
			segment = this.gfService.removeDuplicateArr(segment);
			for (const value of data.segments) {
				if (!findData.segments.includes(value.toString())) {
					newSegments.push(value);
				}
			}
			findData.totalSegment = data.totalSegment;
			findData.newSegments = newSegments;
			findData.segments = segment;
			findData.currentSegment = data.currentSegment;
			findData.currentTime = data.currentTime;
		} else {
			data.segments = this.gfService.removeDuplicateArr(data.segments);
			data.newSegments = data.segments;
			storageData.push(this.gfService.JSONMerge({ resourceID: resourceID }, data));
		}
		return storageData;
	}

	processSegmentDuration(time, resourceID) {
		let storageData: any = [];
		if (localStorage.getItem('segmentData')) {
			storageData = JSON.parse(localStorage.getItem('segmentData'));
		}
		const findData = storageData.find(items => items.resourceID === resourceID);
		if (findData) {
			findData.currentTime = this.gfService.formatTime(time, 'hh:mm:ss');
		} else {
			const pushJson = {
				currentTime: this.gfService.formatTime(time, 'hh:mm:ss')
			};
			storageData.push(this.gfService.JSONMerge({ resourceID: resourceID }, pushJson));
		}
		return storageData;
	}

	getUserShortInfo(data): Array<string> {
		let shortInfo = [];
		if (data) {
			if (data.department && data.department.name) {
				shortInfo.push(data.department.name);
			}
			if (data.location && data.location.name) {
				shortInfo.push(data.location.name);
			}
			let userText = '';
			let status = false;
			if (data.city && data.city.name) {
				userText = `${data.city.name}`;
				status = true;
			}
			if (userText && shortInfo.length) {
				if (shortInfo.length === 1) {
					shortInfo[0] = `${shortInfo[0]}, ${userText}`;
				} else if (shortInfo.length === 2) {
					shortInfo[1] = `${shortInfo[1]}, ${userText}`;
				}
			}
			if (!shortInfo.length && userText) {
				shortInfo = [userText];
			}
			if (!shortInfo.length && !status) {
				if (data.emailID) {
					shortInfo = [data.emailID];
				}
			}
		}
		return shortInfo;
	}

}


type ReferenceType = 'resourceType' | 'assignmentStatus' | 'assignmentType' | 'taskGroup' | 'wgReqStatusType'
	| 'resourceFormat' | 'conversationStatus' | 'profileStatus' | 'resourceStatus' | 'relationShip' | 'courseContentType' | 'questionType' | 'testStatus' | 'testQuestionStatus' | 'commonStatus' | 'badgeStatus'
	| 'notificationStatus' | 'certificationStatus' | 'stimulationSteps' | 'registrationStatus' | 'registrationRequestStatus'
	| 'subscribeStatus';
